import { BlobWriter, ZipWriter, HttpReader } from "@zip.js/zip.js";

const generateFilename = ({ url, filename }) => {
  const { groups } = /(?<extension>.[^.?]+)(\?.+)?$/gm.exec(url);

  return `${filename}${groups.extension}`;
};

export default async function zipUrls(urls) {
  try {
    const blobWriter = new BlobWriter("application/zip");
    const writer = new ZipWriter(blobWriter);
    let progress = 0;
    document.dispatchEvent(new CustomEvent('zip-urls:start'));

    await Promise.all(urls.map(async ({ url, filename }) => {
      await writer.add(generateFilename({ url, filename }), new HttpReader(url));

      progress++;

      document.dispatchEvent(new CustomEvent('zip-urls:progress', {
        detail: {
          total: urls.length,
          progress
        }
      }));
    }));

    await writer.close();

    const blob = await blobWriter.getData();

    document.dispatchEvent(new CustomEvent('zip-urls:end'));

    return blob;

  } catch (error) {
    document.dispatchEvent(new CustomEvent('zip-urls:error'));
    throw error;
  }
};
